import { NgModule } from '@angular/core';
import { SkyNumericPipe } from './numeric.pipe';
import { SkyNumericService } from './numeric.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';


export class SkyNumericModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [SkyNumericPipe],
  providers: [
    SkyNumericService,
    CurrencyPipe,
    DecimalPipe],
  exports: [SkyNumericPipe]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
